<app-event-article-content [pageData]="pageData"></app-event-article-content>
<!-- <app-events-article-apply [pageData]="pageData"></app-events-article-apply> -->
<app-event-article-re-events [pageData]="pageData"></app-event-article-re-events>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
